


//IMPORTANT: this file is auto-generated, any changes included will not be persisted, if extension is required please inherit from this class in separate file and inlcude your changes there
export enum ReportPresetType {
    
    None = <any>"None",
    AgeVsDist = <any>"AgeVsDist",
    AgeVsAccumulativeDist = <any>"AgeVsAccumulativeDist",
    ContastPlateVsDist = <any>"ContastPlateVsDist",
    AverageValueVsOneAge = <any>"AverageValueVsOneAge",
    AverageValueVsOneDist = <any>"AverageValueVsOneDist",
    ActualsVsForecast = <any>"ActualsVsForecast",
    IntroducedSince = <any>"IntroducedSince",
    DiscontinuedSince = <any>"DiscontinuedSince"
}

